import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18c7e8ea")

_pushScopeId("data-v-18c7e8ea")
const _hoisted_1 = { class: "project-card" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" View ")
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Project ")
const _hoisted_5 = { class: "project-body" }
const _hoisted_6 = { class: "snippet" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImageItem = _resolveComponent("ImageItem")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ImageItem, {
      class: "project-img",
      imageClass: 'card-image',
      source: 
        _ctx.getImgUrl(_ctx.project.featuredImage)
          ? _ctx.getImgUrl(_ctx.project.featuredImage)
          : 'https://source.unsplash.com/random'
      ,
      alt: _ctx.project.title
    }, null, 8, ["source", "alt"]),
    _createVNode(_component_router_link, {
      class: "view-project-cta",
      to: { name: 'projects', params: { id: _ctx.project.id } }
    }, {
      default: _withId(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode("div", _hoisted_5, [
      _createVNode("h1", null, _toDisplayString(_ctx.project.title), 1),
      _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.project.intro), 1)
    ])
  ]))
})